var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalPlotter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 446.755 926.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 331.753,
    y1: 306.57,
    x2: 331.753,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7b299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d8c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "425.73 561.68 250.65 561.68 7.77 517.84 156.5 517.84 425.73 561.68",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.65,
    y: 561.68,
    width: 175.08,
    height: 10.69,
    fill: "#f2c2a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.65 561.68 250.65 572.37 7.77 526.92 7.77 517.84 250.65 561.68",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,522.63c-.11,1.35-.25,2.69-.43,4.02-1.19,9.13-3.87,17.88-8.82,25.22l-10.49,.16-42.06,.64-21.79,.34c-5.35,.08-10.7-.49-15.92-1.71l-11.31-2.64-82.62-19.25-14.38-3.35c-3.63-2.25-6.09-5.98-6.7-10.21-.65-4.45-1.38-10.04-1.63-16.31-.06-1.34-.09-2.72-.1-4.13-.06-15.68,3.26-34.68,17.53-50.6,0,0,13.59-12.79,31.01-10l.34,.05,128.76,19.73,21.18,3.24c5.33,2.01,9.4,6.42,10.96,11.89,3.31,11.57,8.16,32.78,6.47,52.91Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,522.63c-.11,1.35-.25,2.69-.43,4.02l-57.48,1.83c-2.35,.07-4.7,.11-7.05,.11-16.79,0-33.55-1.9-49.92-5.68l-101.27-23.37c-.06-1.34-.09-2.72-.1-4.13l102.27,23.6c18.32,4.23,37.14,6.07,55.94,5.47l58.04-1.85Z",
    fill: "#302617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.862,488.875c.962-3.224,2.587-6.203,4.2-9.155,.512-.937,1.863-2.006,2.931-1.971,1.398,.046,1.306,1.901,1.079,3.281-.449,2.728-2.213,5.018-3.65,7.38-3.011,4.95-4.705,10.607-5.405,16.335-.139,1.137-.223,2.265-.246,3.41-.062-5.016-.478-10.092,.202-15.084,.193-1.418,.48-2.824,.889-4.196Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.671,463.287c.117,.032,.236,.069,.334,.141,.187,.139,.261,.379,.323,.603,.255,.907,.505,1.903,.124,2.765-.446,1.009-1.588,1.478-2.626,1.853-.687,.248-1.374,.497-2.061,.745-.869,.314-1.888,.615-2.67,.122-.666-.42-.909-1.318-.749-2.089,.479-2.296,2.985-4.031,5.188-4.289,.713-.083,1.442-.039,2.136,.149Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,482.891c-.608,.605-1.249,1.209-1.614,1.984s-.389,1.782,.184,2.419c.221,.245,.51,.417,.798,.576,2.739,1.511,5.896,2.256,9.022,2.128,.327-.013,.667-.04,.95-.203,.315-.181,.517-.505,.704-.817,1.543-2.58,2.945-5.244,4.198-7.976,1.384-3.018,2.609-6.288,2.183-9.581-.043-.335-.116-.691-.36-.924-.297-.284-.753-.3-1.164-.3-1.545,.003-3.094-.032-4.638,0-.95,.02-1.635,.245-2.154,1.085-.773,1.253-1.331,2.647-2.092,3.915-.796,1.326-1.669,2.606-2.614,3.83-1.05,1.36-2.188,2.653-3.406,3.865Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,552.03l-42.06,.64,1.8-2.7c1.82-2.72,4.86-4.39,8.14-4.45l22.42-.41c4.54-.09,8.39,2.86,9.7,6.92Z",
    fill: "#302617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.42,548.66l-82.62-19.25c3.43-3.36,8.39-4.77,13.16-3.62l59.63,14.36c4.3,1.03,7.86,4.01,9.63,8.06l.2,.45Z",
    fill: "#302617"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.63 454.59 304.2 457.4 199.88 440.38 213.87 434.86 342.63 454.59",
    fill: "#302617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.11,451.61c0,2.18-.89,4.16-2.33,5.59-1.43,1.44-3.41,2.33-5.59,2.33h-46.02c-4.36,0-7.92-3.56-7.92-7.92,0-.44,.04-.88,.11-1.3,.28-1.65,1.07-3.14,2.22-4.29,1.43-1.44,3.41-2.33,5.59-2.33h46.02c3.86,0,7.09,2.8,7.78,6.46,.09,.48,.14,.96,.14,1.46Z",
    fill: "#302617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.97,450.15c-1.11,.92-2.52,1.46-4.05,1.46h-53.73c-1.43,0-2.76-.47-3.83-1.3,.28-1.65,1.07-3.14,2.22-4.29,1.43-1.44,3.41-2.33,5.59-2.33h46.02c3.86,0,7.09,2.8,7.78,6.46Z",
    fill: "#443522"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "210.22 3 210.22 926.77 0 838.31 0 40.01 210.22 3",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.134,
    y: 3,
    width: 11.499,
    height: 923.77,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.245,110.76h0c-1.422,.193-2.573-.447-2.573-1.428v-36.48c0-.981,1.151-1.969,2.573-2.206h0c1.426-.238,2.584,.368,2.584,1.353v36.626c0,.985-1.158,1.941-2.584,2.134Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.963,95.299v-6.993c0-1.947,2.277-3.882,5.097-4.324l4.376-.685c2.852-.447,5.173,.787,5.173,2.756v7.073c0,1.97-2.321,3.904-5.173,4.319l-4.376,.637c-2.82,.411-5.098-.836-5.098-2.784Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.493,107.745h0c-1.472,.199-2.663-.448-2.663-1.447v-37.109c0-.998,1.191-2.006,2.663-2.251h0c1.475-.246,2.674,.367,2.674,1.369v37.26c0,1.002-1.198,1.977-2.674,2.177Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.958,92.036v-7.113c0-1.981,2.356-3.955,5.274-4.412l4.528-.709c2.952-.462,5.354,.786,5.354,2.79v7.196c0,2.004-2.402,3.978-5.354,4.408l-4.528,.659c-2.918,.425-5.274-.838-5.275-2.818Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.523,104.624h0c-1.524,.207-2.757-.45-2.757-1.466v-37.759c0-1.016,1.233-2.045,2.757-2.299h0c1.528-.255,2.769,.366,2.769,1.385v37.916c0,1.02-1.241,2.015-2.769,2.222Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722,88.66v-7.237c0-2.015,2.439-4.031,5.46-4.504l4.689-.734c3.057-.479,5.545,.785,5.545,2.824v7.323c0,2.039-2.488,4.054-5.544,4.5l-4.689,.683c-3.021,.44-5.461-.839-5.461-2.854Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.376,101.392h0c-1.579,.214-2.856-.451-2.856-1.485V61.474c0-1.034,1.277-2.085,2.856-2.348h0c1.583-.264,2.869,.364,2.869,1.402v38.596c0,1.038-1.286,2.054-2.869,2.269Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.295,85.163v-7.366c0-2.051,2.527-4.109,5.657-4.6l4.858-.761c3.167-.496,5.746,.783,5.746,2.859v7.455c0,2.076-2.578,4.134-5.745,4.595l-4.858,.707c-3.13,.456-5.657-.839-5.657-2.89Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.099,98.042h0c-1.637,.222-2.961-.452-2.961-1.505V57.405c0-1.053,1.324-2.127,2.961-2.4h0c1.641-.273,2.974,.361,2.974,1.419v39.3c0,1.057-1.333,2.095-2.974,2.317Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721,81.539v-7.499c0-2.088,2.619-4.191,5.864-4.699l5.036-.789c3.284-.514,5.958,.781,5.958,2.895v7.591c0,2.114-2.673,4.217-5.957,4.695l-5.036,.733c-3.245,.472-5.864-.839-5.864-2.927Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.738,94.567h0c-1.698,.23-3.072-.453-3.072-1.525V53.186c0-1.072,1.374-2.17,3.072-2.453h0c1.702-.284,3.086,.359,3.086,1.436v40.031c0,1.077-1.383,2.137-3.086,2.368Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048,77.782v-7.637c0-2.127,2.717-4.276,6.082-4.803l5.225-.818c3.407-.534,6.182,.778,6.182,2.931v7.733c0,2.153-2.774,4.303-6.181,4.799l-5.225,.761c-3.366,.49-6.083-.838-6.083-2.965Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.347,90.962h0c-1.763,.239-3.189-.453-3.189-1.546V48.808c0-1.092,1.426-2.216,3.189-2.509h0c1.767-.295,3.203,.356,3.203,1.453v40.789c0,1.097-1.436,2.181-3.203,2.421Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.326,73.884v-7.781c0-2.167,2.82-4.365,6.314-4.912l5.424-.849c3.538-.554,6.419,.774,6.419,2.968v7.88c0,2.194-2.88,4.393-6.418,4.908l-5.424,.79c-3.494,.509-6.314-.837-6.314-3.004Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.981,87.217h0c-1.832,.248-3.313-.454-3.313-1.567V44.262c0-1.113,1.481-2.263,3.313-2.568h0c1.836-.306,3.328,.352,3.328,1.471v41.576c0,1.118-1.492,2.227-3.328,2.476Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,69.836v-7.93c0-2.208,2.929-4.457,6.558-5.025l5.635-.882c3.676-.576,6.669,.769,6.669,3.006v8.033c0,2.237-2.993,4.486-6.669,5.021l-5.635,.821c-3.629,.528-6.559-.835-6.559-3.043Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.245,171.229h0c-1.422,.126-2.573-.568-2.573-1.549v-36.48c0-.981,1.151-1.915,2.573-2.085h0c1.426-.171,2.584,.489,2.584,1.475v36.626c0,.985-1.158,1.887-2.584,2.013Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.963,155.427v-6.993c0-1.947,2.277-3.775,5.097-4.085l4.376-.48c2.852-.313,5.173,1.029,5.173,2.999v7.073c0,1.97-2.321,3.795-5.173,4.077l-4.376,.432c-2.82,.278-5.098-1.076-5.098-3.023Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.493,169.258h0c-1.472,.13-2.663-.573-2.663-1.572v-37.109c0-.998,1.191-1.95,2.663-2.126h0c1.475-.177,2.674,.492,2.674,1.495v37.26c0,1.002-1.198,1.921-2.674,2.052Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.958,153.196v-7.113c0-1.981,2.356-3.845,5.274-4.165l4.528-.496c2.952-.324,5.354,1.037,5.354,3.041v7.196c0,2.004-2.402,3.865-5.354,4.156l-4.528,.447c-2.918,.288-5.274-1.085-5.275-3.066Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.523,167.218h0c-1.524,.135-2.757-.579-2.757-1.595v-37.759c0-1.016,1.233-1.987,2.757-2.169h0c1.528-.183,2.769,.495,2.769,1.515v37.916c0,1.02-1.241,1.957-2.769,2.092Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722,150.887v-7.237c0-2.015,2.439-3.916,5.46-4.248l4.689-.514c3.057-.335,5.545,1.045,5.545,3.084v7.323c0,2.039-2.488,3.938-5.544,4.239l-4.689,.463c-3.021,.298-5.461-1.095-5.461-3.11Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.376,165.105h0c-1.579,.14-2.856-.585-2.856-1.619v-38.433c0-1.034,1.277-2.025,2.856-2.214h0c1.583-.189,2.869,.498,2.869,1.537v38.596c0,1.038-1.286,1.994-2.869,2.134Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.295,148.497v-7.366c0-2.051,2.527-3.991,5.657-4.334l4.858-.533c3.167-.347,5.746,1.053,5.746,3.129v7.455c0,2.076-2.578,4.013-5.745,4.326l-4.858,.479c-3.13,.309-5.657-1.105-5.657-3.156Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.099,162.915h0c-1.637,.145-2.961-.591-2.961-1.644v-39.132c0-1.053,1.324-2.065,2.961-2.261h0c1.641-.196,2.974,.501,2.974,1.558v39.3c0,1.057-1.333,2.032-2.974,2.178Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721,146.02v-7.499c0-2.088,2.619-4.068,5.864-4.424l5.036-.552c3.284-.36,5.958,1.06,5.958,3.174v7.591c0,2.114-2.673,4.091-5.957,4.415l-5.036,.497c-3.245,.32-5.864-1.114-5.864-3.203Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.738,160.644h0c-1.698,.15-3.072-.597-3.072-1.669v-39.856c0-1.072,1.374-2.106,3.072-2.309h0c1.702-.204,3.086,.504,3.086,1.58v40.031c0,1.077-1.383,2.072-3.086,2.223Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048,143.451v-7.637c0-2.127,2.717-4.149,6.082-4.518l5.225-.573c3.407-.374,6.182,1.068,6.182,3.221v7.733c0,2.153-2.774,4.173-6.181,4.509l-5.225,.516c-3.366,.332-6.083-1.124-6.083-3.251Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.347,158.287h0c-1.763,.156-3.189-.603-3.189-1.695v-40.607c0-1.092,1.426-2.149,3.189-2.36h0c1.767-.212,3.203,.506,3.203,1.603v40.789c0,1.097-1.436,2.114-3.203,2.271Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.326,140.786v-7.781c0-2.167,2.82-4.232,6.314-4.615l5.424-.595c3.538-.388,6.419,1.075,6.419,3.27v7.88c0,2.194-2.88,4.257-6.418,4.606l-5.424,.535c-3.494,.345-6.314-1.133-6.314-3.3Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.981,155.84h0c-1.832,.162-3.313-.609-3.313-1.722v-41.388c0-1.113,1.481-2.193,3.313-2.413h0c1.836-.22,3.328,.508,3.328,1.627v41.576c0,1.118-1.492,2.157-3.328,2.32Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,138.019v-7.93c0-2.208,2.929-4.319,6.558-4.717l5.635-.618c3.676-.403,6.669,1.082,6.669,3.319v8.033c0,2.237-2.993,4.345-6.669,4.708l-5.635,.556c-3.629,.358-6.559-1.143-6.559-3.351Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.245,231.698h0c-1.422,.059-2.573-.688-2.573-1.67v-36.48c0-.981,1.151-1.861,2.573-1.964h0c1.426-.104,2.584,.611,2.584,1.596v36.626c0,.985-1.158,1.832-2.584,1.892Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.963,215.554v-6.993c0-1.947,2.277-3.669,5.097-3.845l4.376-.274c2.852-.179,5.173,1.272,5.173,3.242v7.073c0,1.97-2.321,3.686-5.173,3.834l-4.376,.226c-2.82,.146-5.098-1.315-5.098-3.262Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.493,230.771h0c-1.472,.061-2.663-.698-2.663-1.697v-37.109c0-.998,1.191-1.894,2.663-2.001h0c1.475-.107,2.674,.618,2.674,1.62v37.26c0,1.002-1.198,1.865-2.674,1.926Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.958,214.355v-7.113c0-1.981,2.356-3.734,5.274-3.917l4.528-.284c2.952-.185,5.354,1.289,5.354,3.292v7.196c0,2.004-2.402,3.752-5.354,3.905l-4.528,.234c-2.918,.151-5.274-1.333-5.275-3.314Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.523,229.812h0c-1.524,.063-2.757-.709-2.757-1.724v-37.759c0-1.016,1.233-1.929,2.757-2.04h0c1.528-.111,2.769,.625,2.769,1.645v37.916c0,1.02-1.241,1.899-2.769,1.962Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722,213.115v-7.237c0-2.015,2.439-3.802,5.46-3.991l4.689-.294c3.057-.192,5.545,1.305,5.545,3.345v7.323c0,2.039-2.488,3.821-5.544,3.979l-4.689,.243c-3.021,.156-5.461-1.351-5.461-3.367Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.376,228.819h0c-1.579,.066-2.856-.719-2.856-1.753v-38.433c0-1.034,1.277-1.965,2.856-2.08h0c1.583-.115,2.869,.633,2.869,1.671v38.596c0,1.038-1.286,1.933-2.869,1.999Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.295,211.831v-7.366c0-2.051,2.527-3.872,5.657-4.069l4.858-.305c3.167-.199,5.746,1.323,5.746,3.398v7.455c0,2.076-2.578,3.892-5.745,4.056l-4.858,.251c-3.13,.162-5.657-1.37-5.657-3.421Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.099,227.789h0c-1.637,.068-2.961-.73-2.961-1.783v-39.132c0-1.053,1.324-2.002,2.961-2.122h0c1.641-.119,2.974,.641,2.974,1.698v39.3c0,1.057-1.333,1.97-2.974,2.038Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721,210.5v-7.499c0-2.088,2.619-3.945,5.864-4.149l5.036-.316c3.284-.206,5.958,1.34,5.958,3.454v7.591c0,2.114-2.673,3.966-5.957,4.136l-5.036,.261c-3.245,.168-5.864-1.389-5.864-3.478Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.738,226.721h0c-1.698,.071-3.072-.741-3.072-1.813v-39.856c0-1.072,1.374-2.041,3.072-2.165h0c1.702-.124,3.086,.648,3.086,1.725v40.031c0,1.077-1.383,2.007-3.086,2.078Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048,209.12v-7.637c0-2.127,2.717-4.021,6.082-4.232l5.225-.328c3.407-.214,6.182,1.358,6.182,3.511v7.733c0,2.153-2.774,4.042-6.181,4.219l-5.225,.27c-3.366,.174-6.083-1.409-6.083-3.536Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.347,225.613h0c-1.763,.073-3.189-.753-3.189-1.845v-40.607c0-1.092,1.426-2.082,3.189-2.21h0c1.767-.129,3.203,.656,3.203,1.754v40.789c0,1.097-1.436,2.047-3.203,2.12Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.326,207.689v-7.781c0-2.167,2.82-4.1,6.314-4.319l5.424-.34c3.538-.222,6.419,1.376,6.419,3.571v7.88c0,2.194-2.88,4.122-6.418,4.305l-5.424,.281c-3.494,.181-6.314-1.43-6.314-3.597Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.981,224.462h0c-1.832,.076-3.313-.765-3.313-1.878v-41.388c0-1.113,1.481-2.124,3.313-2.257h0c1.836-.134,3.328,.664,3.328,1.783v41.576c0,1.118-1.492,2.087-3.328,2.164Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,206.202v-7.93c0-2.208,2.929-4.182,6.558-4.409l5.635-.353c3.676-.231,6.669,1.395,6.669,3.632v8.033c0,2.237-2.993,4.205-6.669,4.395l-5.635,.292c-3.629,.188-6.559-1.451-6.559-3.659Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.245,292.167h0c-1.422-.008-2.573-.809-2.573-1.79v-36.48c0-.981,1.151-1.807,2.573-1.843h0c1.426-.037,2.584,.732,2.584,1.717v36.626c0,.985-1.158,1.778-2.584,1.77Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.963,275.681v-6.993c0-1.947,2.277-3.562,5.097-3.606l4.376-.069c2.852-.045,5.173,1.515,5.173,3.485v7.073c0,1.97-2.321,3.577-5.173,3.591l-4.376,.021c-2.82,.014-5.098-1.554-5.098-3.501Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.493,292.284h0c-1.472-.008-2.663-.823-2.663-1.822v-37.109c0-.998,1.191-1.838,2.663-1.876h0c1.475-.038,2.674,.743,2.674,1.746v37.26c0,1.002-1.198,1.809-2.674,1.801Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.958,275.515v-7.113c0-1.981,2.356-3.624,5.274-3.67l4.528-.071c2.952-.047,5.354,1.54,5.354,3.544v7.196c0,2.004-2.402,3.64-5.354,3.654l-4.528,.022c-2.918,.014-5.274-1.58-5.275-3.561Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.523,292.406h0c-1.524-.008-2.757-.838-2.757-1.854v-37.759c0-1.016,1.233-1.871,2.757-1.91h0c1.528-.039,2.769,.755,2.769,1.775v37.916c0,1.02-1.241,1.84-2.769,1.832Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722,275.343v-7.237c0-2.015,2.439-3.687,5.46-3.735l4.689-.074c3.057-.048,5.545,1.566,5.545,3.605v7.323c0,2.039-2.488,3.704-5.544,3.719l-4.689,.023c-3.021,.015-5.461-1.607-5.461-3.623Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.376,292.532h0c-1.579-.008-2.856-.853-2.856-1.887v-38.433c0-1.034,1.277-1.905,2.856-1.946h0c1.583-.041,2.869,.768,2.869,1.806v38.596c0,1.038-1.286,1.873-2.869,1.865Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.295,275.165v-7.366c0-2.051,2.527-3.754,5.657-3.803l4.858-.077c3.167-.05,5.746,1.592,5.746,3.668v7.455c0,2.076-2.578,3.771-5.745,3.786l-4.858,.023c-3.13,.015-5.657-1.636-5.657-3.687Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.099,292.663h0c-1.637-.009-2.961-.869-2.961-1.922v-39.132c0-1.053,1.324-1.94,2.961-1.983h0c1.641-.042,2.974,.78,2.974,1.837v39.3c0,1.057-1.333,1.907-2.974,1.899Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721,274.981v-7.499c0-2.088,2.619-3.822,5.864-3.874l5.036-.079c3.284-.052,5.958,1.62,5.958,3.734v7.591c0,2.114-2.673,3.84-5.957,3.856l-5.036,.024c-3.245,.016-5.864-1.665-5.864-3.753Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.738,292.798h0c-1.698-.009-3.072-.885-3.072-1.958v-39.856c0-1.072,1.374-1.977,3.072-2.021h0c1.702-.044,3.086,.793,3.086,1.87v40.031c0,1.077-1.383,1.943-3.086,1.934Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048,274.789v-7.637c0-2.127,2.717-3.894,6.082-3.947l5.225-.082c3.407-.054,6.182,1.648,6.182,3.802v7.733c0,2.153-2.774,3.912-6.181,3.929l-5.225,.025c-3.366,.016-6.083-1.695-6.083-3.822Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.347,292.939h0c-1.763-.009-3.189-.902-3.189-1.995v-40.607c0-1.092,1.426-2.015,3.189-2.06h0c1.767-.046,3.203,.807,3.203,1.904v40.789c0,1.097-1.436,1.979-3.203,1.97Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.326,274.591v-7.781c0-2.167,2.82-3.968,6.314-4.023l5.424-.086c3.538-.056,6.419,1.678,6.419,3.872v7.88c0,2.194-2.88,3.987-6.418,4.004l-5.424,.026c-3.494,.017-6.314-1.726-6.314-3.893Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.981,293.085h0c-1.832-.01-3.313-.92-3.313-2.033v-41.388c0-1.113,1.481-2.054,3.313-2.102h0c1.836-.047,3.328,.821,3.328,1.939v41.576c0,1.118-1.492,2.017-3.328,2.008Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,274.385v-7.93c0-2.208,2.929-4.044,6.558-4.102l5.635-.089c3.676-.058,6.669,1.708,6.669,3.945v8.033c0,2.237-2.993,4.065-6.669,4.082l-5.635,.027c-3.629,.017-6.559-1.759-6.559-3.967Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.245,352.636h0c-1.422-.074-2.573-.93-2.573-1.911v-36.48c0-.981,1.151-1.753,2.573-1.723h0c1.426,.03,2.584,.853,2.584,1.838v36.626c0,.985-1.158,1.724-2.584,1.649Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.963,335.808v-6.993c0-1.947,2.277-3.455,5.097-3.367l4.376,.136c2.852,.089,5.173,1.758,5.173,3.727v7.073c0,1.97-2.321,3.468-5.173,3.348l-4.376-.184c-2.82-.119-5.098-1.793-5.098-3.741Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.493,353.797h0c-1.472-.077-2.663-.948-2.663-1.947v-37.109c0-.998,1.191-1.782,2.663-1.751h0c1.475,.031,2.674,.869,2.674,1.871v37.26c0,1.002-1.198,1.752-2.674,1.675Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.958,336.674v-7.113c0-1.981,2.356-3.513,5.274-3.422l4.528,.141c2.952,.092,5.354,1.791,5.354,3.795v7.196c0,2.004-2.402,3.527-5.354,3.403l-4.528-.191c-2.918-.123-5.274-1.828-5.275-3.809Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.523,355h0c-1.524-.08-2.757-.967-2.757-1.983v-37.759c0-1.016,1.233-1.813,2.757-1.781h0c1.528,.032,2.769,.885,2.769,1.905v37.916c0,1.02-1.241,1.782-2.769,1.702Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722,337.571v-7.237c0-2.015,2.439-3.573,5.46-3.479l4.689,.146c3.057,.095,5.545,1.826,5.545,3.865v7.323c0,2.039-2.488,3.587-5.544,3.459l-4.689-.197c-3.021-.127-5.461-1.864-5.461-3.879Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.376,356.245h0c-1.579-.082-2.856-.987-2.856-2.021v-38.433c0-1.034,1.277-1.845,2.856-1.812h0c1.583,.033,2.869,.902,2.869,1.94v38.596c0,1.038-1.286,1.813-2.869,1.73Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.295,338.499v-7.366c0-2.051,2.527-3.635,5.657-3.538l4.858,.151c3.167,.099,5.746,1.862,5.746,3.938v7.455c0,2.076-2.578,3.65-5.745,3.517l-4.858-.205c-3.13-.132-5.657-1.901-5.657-3.952Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.099,357.536h0c-1.637-.085-2.961-1.008-2.961-2.061v-39.132c0-1.053,1.324-1.878,2.961-1.844h0c1.641,.035,2.974,.92,2.974,1.977v39.3c0,1.057-1.333,1.845-2.974,1.759Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721,339.461v-7.499c0-2.088,2.619-3.7,5.864-3.598l5.036,.157c3.284,.102,5.958,1.899,5.958,4.013v7.591c0,2.114-2.673,3.715-5.957,3.577l-5.036-.212c-3.245-.137-5.864-1.94-5.864-4.028Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.738,358.875h0c-1.698-.089-3.072-1.03-3.072-2.102v-39.856c0-1.072,1.374-1.912,3.072-1.877h0c1.702,.036,3.086,.938,3.086,2.015v40.031c0,1.077-1.383,1.878-3.086,1.789Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048,340.458v-7.637c0-2.127,2.717-3.766,6.082-3.661l5.225,.163c3.407,.106,6.182,1.938,6.182,4.092v7.733c0,2.153-2.774,3.782-6.181,3.639l-5.225-.22c-3.366-.142-6.083-1.98-6.083-4.107Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.347,360.265h0c-1.763-.092-3.189-1.052-3.189-2.144v-40.607c0-1.092,1.426-1.948,3.189-1.911h0c1.767,.037,3.203,.957,3.203,2.054v40.789c0,1.097-1.436,1.912-3.203,1.819Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.326,341.493v-7.781c0-2.167,2.82-3.835,6.314-3.726l5.424,.169c3.538,.11,6.419,1.979,6.419,4.173v7.88c0,2.194-2.88,3.852-6.418,3.703l-5.424-.228c-3.494-.147-6.314-2.022-6.314-4.189Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.981,361.708h0c-1.832-.096-3.313-1.076-3.313-2.189v-41.388c0-1.113,1.481-1.985,3.313-1.946h0c1.836,.039,3.328,.977,3.328,2.095v41.576c0,1.118-1.492,1.947-3.328,1.851Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,342.568v-7.93c0-2.208,2.929-3.907,6.558-3.794l5.635,.176c3.676,.115,6.669,2.021,6.669,4.258v8.033c0,2.237-2.993,3.924-6.669,3.769l-5.635-.237c-3.629-.153-6.559-2.066-6.559-4.275Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.245,413.105h0c-1.422-.141-2.573-1.051-2.573-2.032v-36.48c0-.981,1.151-1.699,2.573-1.602h0c1.426,.097,2.584,.974,2.584,1.96v36.626c0,.985-1.158,1.669-2.584,1.528Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.963,395.936v-6.993c0-1.947,2.277-3.348,5.097-3.128l4.376,.342c2.852,.223,5.173,2.001,5.173,3.97v7.073c0,1.97-2.321,3.359-5.173,3.106l-4.376-.39c-2.82-.251-5.098-2.033-5.098-3.98Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.493,415.31h0c-1.472-.146-2.663-1.073-2.663-2.072v-37.109c0-.998,1.191-1.727,2.663-1.626h0c1.475,.1,2.674,.994,2.674,1.997v37.26c0,1.002-1.198,1.696-2.674,1.55Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.958,397.834v-7.113c0-1.981,2.356-3.402,5.274-3.175l4.528,.354c2.952,.23,5.354,2.042,5.354,4.046v7.196c0,2.004-2.402,3.414-5.354,3.151l-4.528-.403c-2.918-.26-5.274-2.075-5.275-4.056Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.523,417.594h0c-1.524-.151-2.757-1.097-2.757-2.113v-37.759c0-1.016,1.233-1.755,2.757-1.652h0c1.528,.104,2.769,1.015,2.769,2.035v37.916c0,1.02-1.241,1.724-2.769,1.572Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722,399.799v-7.237c0-2.015,2.439-3.459,5.46-3.223l4.689,.366c3.057,.239,5.545,2.086,5.545,4.125v7.323c0,2.039-2.488,3.471-5.544,3.198l-4.689-.417c-3.021-.269-5.461-2.12-5.461-4.135Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.376,419.959h0c-1.579-.157-2.856-1.121-2.856-2.155v-38.433c0-1.034,1.277-1.785,2.856-1.678h0c1.583,.108,2.869,1.037,2.869,2.075v38.596c0,1.038-1.286,1.752-2.869,1.596Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.294,401.833v-7.366c0-2.051,2.527-3.517,5.657-3.272l4.858,.379c3.167,.247,5.746,2.132,5.746,4.207v7.455c0,2.076-2.578,3.529-5.745,3.247l-4.858-.433c-3.13-.279-5.657-2.167-5.657-4.218Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.099,422.41h0c-1.637-.162-2.961-1.147-2.961-2.2v-39.132c0-1.053,1.324-1.816,2.961-1.705h0c1.641,.112,2.974,1.059,2.974,2.117v39.3c0,1.057-1.333,1.782-2.974,1.619Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721,403.942v-7.499c0-2.088,2.619-3.577,5.864-3.323l5.036,.393c3.284,.256,5.958,2.179,5.958,4.293v7.591c0,2.114-2.673,3.589-5.957,3.297l-5.036-.448c-3.245-.289-5.864-2.215-5.864-4.303Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.738,424.952h0c-1.698-.168-3.072-1.174-3.072-2.246v-39.856c0-1.072,1.374-1.848,3.072-1.732h0c1.702,.116,3.086,1.083,3.086,2.16v40.031c0,1.077-1.383,1.813-3.086,1.644Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.048,406.128v-7.637c0-2.127,2.717-3.639,6.082-3.376l5.225,.408c3.407,.266,6.182,2.228,6.182,4.382v7.733c0,2.153-2.774,3.652-6.181,3.349l-5.225-.465c-3.366-.3-6.083-2.266-6.083-4.393Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.347,427.59h0c-1.763-.175-3.189-1.202-3.189-2.294v-40.607c0-1.092,1.426-1.881,3.189-1.761h0c1.767,.12,3.203,1.107,3.203,2.205v40.789c0,1.097-1.436,1.844-3.203,1.669Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.326,408.396v-7.781c0-2.167,2.82-3.703,6.314-3.43l5.424,.424c3.538,.276,6.419,2.28,6.419,4.474v7.88c0,2.194-2.88,3.717-6.418,3.402l-5.424-.483c-3.494-.311-6.314-2.319-6.314-4.486Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.981,430.33h0c-1.832-.182-3.313-1.231-3.313-2.344v-41.388c0-1.113,1.481-1.915,3.313-1.791h0c1.836,.125,3.328,1.133,3.328,2.251v41.576c0,1.118-1.492,1.877-3.328,1.695Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,410.751v-7.93c0-2.208,2.929-3.77,6.558-3.486l5.635,.44c3.676,.287,6.669,2.334,6.669,4.571v8.033c0,2.237-2.993,3.784-6.669,3.456l-5.635-.502c-3.629-.323-6.559-2.374-6.559-4.582Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.859,488.936h0c-1.493-.229-2.702-1.188-2.702-2.143l-.004-35.488c0-.954,1.208-1.564,2.7-1.362h0c1.494,.202,2.707,1.142,2.707,2.099l.006,35.576c0,.957-1.213,1.548-2.708,1.319Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.202,471.736v-6.812c0-1.897,2.396-3.096,5.36-2.677l4.589,.648c2.985,.421,5.411,2.312,5.411,4.223l.002,6.86c0,1.911-2.425,3.102-5.41,2.662l-4.59-.677c-2.965-.437-5.362-2.329-5.362-4.226Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.047,492.49h0c-1.525-.234-2.76-1.205-2.76-2.171l-.014-35.865c0-.964,1.233-1.579,2.757-1.373h0c1.526,.207,2.765,1.158,2.766,2.125l.017,35.955c0,.968-1.238,1.562-2.765,1.328Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.222,475.095l-.002-6.884c0-1.917,2.447-3.125,5.474-2.698l4.687,.662c3.048,.43,5.527,2.345,5.528,4.276l.004,6.934c.001,1.931-2.476,3.131-5.525,2.681l-4.688-.691c-3.028-.446-5.477-2.362-5.477-4.279Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.731,496.119h0c-1.558-.239-2.819-1.223-2.82-2.198l-.025-36.25c0-.975,1.259-1.594,2.816-1.383h0c1.559,.211,2.825,1.175,2.826,2.152l.027,36.342c0,.978-1.265,1.577-2.824,1.338Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.734,478.525l-.004-6.958c-.001-1.937,2.498-3.155,5.59-2.718l4.788,.676c3.114,.44,5.646,2.379,5.648,4.33l.006,7.008c.002,1.952-2.528,3.161-5.643,2.702l-4.789-.706c-3.093-.456-5.595-2.396-5.596-4.334Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.928,499.828h0c-1.591-.244-2.881-1.241-2.882-2.227l-.036-36.643c0-.985,1.286-1.61,2.877-1.394h0c1.593,.216,2.887,1.192,2.888,2.179l.038,36.737c.001,.989-1.292,1.592-2.885,1.348Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.753,482.03l-.006-7.033c-.002-1.958,2.551-3.185,5.711-2.739l4.892,.691c3.182,.449,5.77,2.414,5.772,4.386l.008,7.085c.002,1.973-2.582,3.191-5.765,2.722l-4.893-.722c-3.16-.466-5.717-2.431-5.718-4.39Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.655,503.617h0c-1.626-.249-2.944-1.259-2.945-2.256l-.047-37.045c-.001-.996,1.314-1.625,2.939-1.405h0c1.628,.22,2.95,1.209,2.952,2.208l.05,37.141c.001,1-1.32,1.607-2.948,1.358Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.295,485.611l-.009-7.11c-.002-1.98,2.606-3.216,5.835-2.76l4.999,.706c3.252,.459,5.898,2.449,5.9,4.444l.01,7.163c.003,1.995-2.638,3.222-5.891,2.743l-5-.737c-3.229-.476-5.843-2.467-5.845-4.447Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.928,507.49h0c-1.663-.255-3.01-1.278-3.011-2.286l-.059-37.456c-.002-1.007,1.342-1.641,3.004-1.416h0c1.664,.225,3.016,1.227,3.018,2.237l.062,37.554c.002,1.011-1.348,1.623-3.013,1.368Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.378,489.271l-.011-7.189c-.003-2.002,2.663-3.247,5.963-2.781l5.111,.722c3.325,.469,6.03,2.486,6.033,4.502l.012,7.243c.003,2.017-2.696,3.254-6.021,2.763l-5.112-.754c-3.301-.487-5.973-2.504-5.976-4.506Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.767,511.45h0c-1.7-.261-3.078-1.298-3.08-2.317l-.071-37.876c-.002-1.018,1.372-1.658,3.071-1.428h0c1.702,.23,3.084,1.245,3.086,2.266l.074,37.976c.002,1.022-1.378,1.639-3.081,1.378Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.02,493.012l-.013-7.269c-.004-2.024,2.722-3.28,6.096-2.803l5.226,.738c3.4,.48,6.166,2.523,6.17,4.563l.015,7.324c.004,2.04-2.756,3.286-6.156,2.785l-5.227-.771c-3.375-.498-6.107-2.542-6.111-4.566Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.19,515.5h0c-1.739-.266-3.148-1.318-3.15-2.349l-.084-38.305c-.002-1.03,1.403-1.674,3.14-1.439h0c1.74,.236,3.155,1.264,3.157,2.297l.087,38.408c.002,1.034-1.409,1.655-3.15,1.388Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.239,496.838l-.016-7.352c-.004-2.047,2.782-3.312,6.233-2.825l5.344,.755c3.477,.491,6.307,2.562,6.312,4.625l.017,7.408c.005,2.063-2.818,3.319-6.295,2.806l-5.345-.788c-3.452-.509-6.246-2.58-6.251-4.628Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.867,547.786h0c-1.494-.269-2.704-1.262-2.704-2.219l-.004-35.539c0-.956,1.209-1.534,2.702-1.292h0c1.495,.243,2.709,1.216,2.709,2.174l.006,35.627c0,.959-1.214,1.517-2.71,1.248Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.205,530.356v-6.822c0-1.899,2.398-3.036,5.364-2.538l4.592,.772c2.987,.502,5.415,2.461,5.415,4.374l.002,6.87c0,1.913-2.427,3.041-5.414,2.52l-4.593-.801c-2.967-.517-5.366-2.476-5.366-4.376Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.072,551.966h0c-1.526-.275-2.762-1.281-2.762-2.248l-.014-35.916c0-.966,1.234-1.548,2.759-1.301h0c1.527,.248,2.767,1.234,2.768,2.202l.017,36.007c0,.969-1.239,1.531-2.767,1.256Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.242,534.337l-.002-6.894c0-1.92,2.448-3.064,5.478-2.555l4.69,.788c3.051,.513,5.531,2.497,5.532,4.43l.004,6.944c.001,1.934-2.478,3.069-5.529,2.537l-4.691-.818c-3.03-.528-5.481-2.512-5.481-4.432Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.774,556.235h0c-1.559-.281-2.821-1.3-2.822-2.277l-.025-36.302c0-.976,1.26-1.563,2.818-1.31h0c1.56,.253,2.827,1.252,2.828,2.231l.027,36.395c0,.979-1.266,1.545-2.826,1.264Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.771,538.402l-.004-6.968c-.001-1.94,2.5-3.092,5.594-2.572l4.791,.805c3.117,.524,5.651,2.534,5.652,4.488l.006,7.019c.002,1.955-2.53,3.098-5.647,2.554l-4.792-.835c-3.095-.54-5.599-2.549-5.6-4.49Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.989,560.597h0c-1.593-.287-2.883-1.32-2.884-2.307l-.036-36.697c0-.987,1.287-1.577,2.879-1.319h0c1.594,.259,2.889,1.271,2.89,2.26l.038,36.791c.001,.99-1.293,1.56-2.888,1.272Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.808,542.555l-.006-7.044c-.002-1.961,2.553-3.121,5.715-2.59l4.896,.823c3.184,.535,5.774,2.572,5.777,4.547l.008,7.095c.002,1.976-2.584,3.127-5.769,2.571l-4.896-.854c-3.162-.551-5.721-2.588-5.723-4.549Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.735,565.055h0c-1.628-.293-2.946-1.34-2.948-2.339l-.047-37.1c-.001-.998,1.315-1.592,2.942-1.328h0c1.629,.264,2.953,1.29,2.954,2.29l.05,37.196c.001,1.001-1.321,1.574-2.951,1.281Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.368,546.799l-.009-7.121c-.002-1.983,2.608-3.151,5.839-2.608l5.003,.841c3.255,.547,5.902,2.611,5.905,4.608l.01,7.174c.003,1.998-2.64,3.156-5.896,2.589l-5.004-.872c-3.232-.563-5.847-2.627-5.849-4.61Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.028,569.611h0c-1.664-.3-3.012-1.361-3.014-2.37l-.059-37.512c-.002-1.009,1.344-1.608,3.007-1.338h0c1.665,.27,3.019,1.309,3.02,2.321l.062,37.61c.002,1.012-1.35,1.589-3.016,1.289Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.471,551.136l-.011-7.2c-.003-2.005,2.665-3.181,5.968-2.626l5.115,.86c3.327,.559,6.034,2.651,6.038,4.671l.012,7.254c.003,2.02-2.698,3.186-6.026,2.606l-5.116-.892c-3.304-.576-5.977-2.667-5.98-4.672Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.887,574.27h0c-1.701-.306-3.08-1.382-3.082-2.403l-.071-37.933c-.002-1.02,1.373-1.623,3.074-1.347h0c1.703,.276,3.087,1.33,3.089,2.352l.074,38.034c.002,1.024-1.379,1.604-3.083,1.297Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.133,555.57l-.013-7.28c-.004-2.027,2.724-3.211,6.101-2.644l5.23,.879c3.402,.572,6.171,2.692,6.175,4.735l.015,7.335c.004,2.043-2.758,3.217-6.161,2.624l-5.231-.912c-3.378-.589-6.112-2.709-6.116-4.737Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.332,579.033h0c-1.74-.313-3.151-1.404-3.153-2.437l-.084-38.364c-.002-1.032,1.404-1.639,3.143-1.357h0c1.742,.283,3.157,1.351,3.16,2.385l.087,38.467c.002,1.035-1.41,1.62-3.153,1.306Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.374,560.104l-.016-7.363c-.004-2.05,2.785-3.243,6.238-2.662l5.349,.899c3.48,.585,6.312,2.735,6.317,4.801l.017,7.419c.005,2.066-2.82,3.248-6.3,2.641l-5.35-.933c-3.455-.602-6.251-2.752-6.256-4.802Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.876,606.719h0c-1.495-.31-2.706-1.337-2.706-2.294l-.004-35.589c0-.957,1.21-1.504,2.704-1.221h0c1.496,.283,2.711,1.291,2.711,2.25l.006,35.678c0,.96-1.215,1.487-2.712,1.177Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.208,589.06v-6.832c0-1.902,2.4-2.976,5.368-2.397l4.596,.896c2.989,.583,5.419,2.609,5.419,4.525l.002,6.88c0,1.916-2.429,2.98-5.418,2.379l-4.596-.925c-2.969-.598-5.37-2.623-5.37-4.526Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.097,611.527h0c-1.527-.316-2.764-1.357-2.764-2.325l-.014-35.968c0-.967,1.235-1.517,2.761-1.229h0c1.528,.289,2.769,1.31,2.77,2.279l.017,36.058c0,.97-1.24,1.5-2.769,1.184Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.262,593.663l-.002-6.904c0-1.922,2.45-3.003,5.482-2.412l4.694,.915c3.053,.595,5.535,2.648,5.536,4.585l.004,6.954c.001,1.937-2.48,3.007-5.533,2.393l-4.694-.945c-3.032-.61-5.485-2.663-5.485-4.585Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.817,616.439h0c-1.56-.323-2.823-1.378-2.824-2.356l-.025-36.355c0-.978,1.261-1.531,2.82-1.236h0c1.561,.295,2.829,1.33,2.83,2.31l.027,36.448c0,.981-1.267,1.514-2.829,1.19Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.808,598.365l-.004-6.978c-.001-1.943,2.502-3.03,5.599-2.426l4.795,.935c3.119,.608,5.655,2.689,5.656,4.646l.006,7.029c.002,1.957-2.532,3.034-5.651,2.406l-4.796-.965c-3.097-.623-5.603-2.703-5.604-4.646Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.05,621.456h0c-1.594-.33-2.885-1.399-2.886-2.388l-.036-36.751c0-.988,1.288-1.545,2.881-1.244h0c1.595,.302,2.891,1.35,2.892,2.341l.038,36.845c.001,.992-1.294,1.527-2.89,1.197Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.862,603.169l-.006-7.054c-.002-1.964,2.555-3.057,5.719-2.441l4.899,.955c3.187,.621,5.779,2.73,5.781,4.709l.008,7.106c.002,1.979-2.586,3.062-5.774,2.42l-4.9-.986c-3.165-.637-5.725-2.745-5.727-4.709Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.815,626.584h0c-1.629-.337-2.949-1.421-2.95-2.421l-.047-37.155c-.001-.999,1.316-1.56,2.944-1.251h0c1.63,.308,2.955,1.371,2.956,2.372l.05,37.251c.001,1.003-1.322,1.541-2.953,1.203Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.442,608.077l-.009-7.131c-.002-1.986,2.61-3.085,5.844-2.455l5.007,.976c3.257,.635,5.907,2.773,5.91,4.773l.01,7.184c.003,2.001-2.643,3.09-5.9,2.434l-5.008-1.008c-3.234-.651-5.852-2.787-5.854-4.774Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.128,631.825h0c-1.665-.345-3.015-1.444-3.016-2.455l-.059-37.568c-.002-1.01,1.345-1.574,3.009-1.259h0c1.667,.315,3.021,1.392,3.023,2.405l.062,37.667c.002,1.014-1.351,1.555-3.018,1.21Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.564,613.094l-.011-7.211c-.003-2.008,2.667-3.114,5.973-2.47l5.119,.998c3.33,.649,6.039,2.817,6.043,4.839l.012,7.265c.003,2.023-2.701,3.119-6.031,2.448l-5.12-1.03c-3.306-.665-5.982-2.831-5.985-4.84Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.008,637.184h0c-1.703-.353-3.083-1.467-3.085-2.489l-.071-37.991c-.002-1.021,1.374-1.589,3.076-1.267h0c1.704,.322,3.089,1.414,3.091,2.439l.074,38.092c.002,1.025-1.381,1.57-3.086,1.217Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.247,618.222l-.013-7.291c-.004-2.03,2.726-3.143,6.106-2.484l5.234,1.02c3.405,.664,6.176,2.862,6.18,4.907l.015,7.347c.004,2.046-2.76,3.148-6.166,2.462l-5.235-1.054c-3.381-.68-6.117-2.877-6.121-4.907Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.475,642.664h0c-1.742-.361-3.153-1.491-3.155-2.525l-.084-38.423c-.002-1.033,1.405-1.604,3.146-1.275h0c1.743,.33,3.16,1.437,3.162,2.473l.088,38.526c.002,1.037-1.411,1.584-3.156,1.223Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.509,623.467l-.016-7.374c-.004-2.053,2.787-3.173,6.243-2.499l5.353,1.044c3.483,.679,6.318,2.908,6.322,4.977l.017,7.431c.005,2.069-2.822,3.177-6.306,2.476l-5.354-1.078c-3.457-.696-6.256-2.923-6.261-4.977Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.885,665.736h0c-1.496-.35-2.708-1.411-2.708-2.37l-.004-35.64c0-.958,1.211-1.473,2.706-1.15h0c1.497,.324,2.713,1.365,2.713,2.326l.006,35.728c0,.962-1.216,1.456-2.714,1.106Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.211,647.846v-6.841c0-1.905,2.401-2.916,5.372-2.257l4.599,1.021c2.991,.664,5.423,2.758,5.423,4.677l.002,6.89c0,1.919-2.43,2.919-5.422,2.237l-4.6-1.05c-2.971-.678-5.374-2.771-5.374-4.676Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.123,671.175h0c-1.528-.358-2.766-1.433-2.766-2.402l-.014-36.02c0-.969,1.236-1.486,2.763-1.156h0c1.529,.331,2.771,1.386,2.772,2.357l.017,36.11c0,.972-1.241,1.469-2.771,1.111Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.281,653.075l-.002-6.914c0-1.925,2.452-2.941,5.486-2.268l4.697,1.042c3.055,.678,5.539,2.801,5.54,4.74l.004,6.964c.001,1.939-2.481,2.945-5.537,2.248l-4.698-1.072c-3.034-.692-5.489-2.813-5.489-4.739Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.86,676.729h0c-1.561-.365-2.825-1.455-2.826-2.435l-.025-36.408c0-.979,1.262-1.5,2.822-1.162h0c1.562,.338,2.831,1.407,2.832,2.389l.027,36.501c0,.982-1.267,1.482-2.831,1.116Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.845,658.415l-.004-6.988c-.001-1.946,2.504-2.967,5.603-2.279l4.798,1.065c3.121,.693,5.659,2.844,5.661,4.804l.006,7.039c.002,1.96-2.534,2.971-5.656,2.258l-4.799-1.095c-3.1-.707-5.607-2.857-5.608-4.804Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.111,682.405h0c-1.595-.373-2.887-1.478-2.888-2.469l-.036-36.804c0-.99,1.289-1.513,2.883-1.168h0c1.596,.345,2.893,1.429,2.894,2.422l.038,36.899c.001,.993-1.295,1.495-2.892,1.121Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.917,663.871l-.006-7.064c-.002-1.967,2.557-2.993,5.724-2.291l4.903,1.088c3.189,.708,5.783,2.889,5.785,4.871l.008,7.116c.002,1.982-2.588,2.997-5.778,2.269l-4.904-1.119c-3.167-.723-5.73-2.902-5.731-4.87Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.895,688.204h0c-1.63-.381-2.951-1.502-2.952-2.504l-.047-37.21c-.001-1.001,1.317-1.526,2.946-1.174h0c1.632,.353,2.957,1.452,2.959,2.455l.05,37.307c.001,1.004-1.323,1.508-2.955,1.126Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.516,669.446l-.009-7.142c-.002-1.989,2.612-3.02,5.848-2.302l5.011,1.112c3.26,.723,5.911,2.935,5.914,4.939l.01,7.195c.003,2.004-2.645,3.023-5.905,2.279l-5.012-1.144c-3.237-.739-5.856-2.948-5.859-4.938Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.228,694.133h0c-1.667-.39-3.017-1.527-3.019-2.539l-.059-37.624c-.002-1.012,1.346-1.54,3.011-1.18h0c1.668,.361,3.023,1.475,3.025,2.49l.062,37.723c.002,1.015-1.352,1.521-3.021,1.131Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.657,675.144l-.011-7.221c-.003-2.011,2.669-3.047,5.977-2.313l5.123,1.137c3.333,.74,6.044,2.983,6.048,5.009l.013,7.275c.003,2.026-2.703,3.051-6.036,2.29l-5.124-1.169c-3.309-.755-5.987-2.996-5.99-5.007Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.129,700.194h0c-1.704-.399-3.085-1.552-3.087-2.576l-.072-38.048c-.002-1.023,1.375-1.554,3.079-1.186h0c1.706,.369,3.092,1.499,3.094,2.525l.075,38.149c.002,1.027-1.382,1.535-3.088,1.136Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.36,680.969l-.013-7.302c-.004-2.033,2.728-3.075,6.111-2.324l5.238,1.162c3.408,.756,6.181,3.032,6.185,5.08l.015,7.358c.004,2.049-2.763,3.078-6.171,2.3l-5.239-1.196c-3.383-.772-6.122-3.045-6.126-5.079Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.617,706.393h0c-1.743-.408-3.156-1.578-3.158-2.613l-.085-38.482c-.002-1.035,1.406-1.569,3.148-1.192h0c1.745,.377,3.163,1.524,3.165,2.562l.088,38.585c.002,1.038-1.413,1.549-3.158,1.14Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.644,686.926l-.016-7.385c-.004-2.056,2.789-3.103,6.249-2.335l5.358,1.189c3.486,.773,6.323,3.082,6.328,5.154l.018,7.442c.005,2.073-2.825,3.106-6.311,2.311l-5.359-1.223c-3.46-.79-6.262-3.096-6.266-5.153Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.893,724.838h0c-1.497-.391-2.71-1.486-2.71-2.446l-.004-35.69c0-.96,1.211-1.443,2.708-1.079h0c1.499,.364,2.715,1.44,2.715,2.402l.006,35.779c0,.963-1.217,1.426-2.716,1.035Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.214,706.716v-6.851c0-1.908,2.403-2.856,5.376-2.116l4.602,1.145c2.993,.745,5.426,2.908,5.427,4.829l.002,6.9c0,1.922-2.432,2.858-5.426,2.094l-4.603-1.175c-2.973-.759-5.378-2.919-5.378-4.827Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.148,730.907h0c-1.529-.399-2.768-1.509-2.768-2.48l-.014-36.071c0-.97,1.237-1.455,2.765-1.084h0c1.531,.372,2.773,1.462,2.774,2.435l.017,36.162c0,.973-1.242,1.438-2.773,1.038Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.301,712.571l-.002-6.924c0-1.928,2.454-2.88,5.49-2.124l4.701,1.17c3.057,.761,5.543,2.953,5.544,4.895l.004,6.974c.001,1.942-2.483,2.882-5.541,2.102l-4.701-1.2c-3.037-.775-5.493-2.965-5.493-4.893Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.903,737.108h0c-1.562-.408-2.828-1.533-2.828-2.515l-.025-36.461c0-.98,1.263-1.468,2.824-1.088h0c1.564,.38,2.833,1.485,2.834,2.468l.027,36.554c0,.984-1.268,1.45-2.833,1.042Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.882,718.552l-.004-6.999c-.001-1.949,2.506-2.904,5.607-2.132l4.802,1.195c3.123,.777,5.663,3,5.665,4.963l.006,7.049c.002,1.963-2.536,2.907-5.66,2.11l-4.803-1.226c-3.102-.792-5.611-3.012-5.613-4.961Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.173,743.442h0c-1.596-.417-2.889-1.558-2.89-2.55l-.036-36.858c0-.991,1.29-1.48,2.885-1.093h0c1.598,.388,2.895,1.509,2.896,2.503l.038,36.954c.001,.995-1.296,1.462-2.894,1.045Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.972,724.662l-.006-7.075c-.002-1.97,2.559-2.929,5.728-2.14l4.907,1.221c3.192,.794,5.788,3.049,5.79,5.033l.008,7.127c.002,1.985-2.59,2.932-5.783,2.117l-4.908-1.252c-3.17-.809-5.734-3.06-5.736-5.031Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.975,749.916h0c-1.631-.426-2.953-1.584-2.955-2.587l-.047-37.265c-.001-1.002,1.318-1.493,2.949-1.097h0c1.633,.397,2.96,1.534,2.961,2.538l.05,37.362c.001,1.006-1.324,1.475-2.958,1.048Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,730.905l-.009-7.153c-.002-1.992,2.614-2.954,5.853-2.148l5.015,1.248c3.262,.812,5.916,3.098,5.919,5.105l.01,7.206c.003,2.007-2.647,2.957-5.909,2.124l-5.016-1.28c-3.239-.827-5.861-3.11-5.863-5.102Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.328,756.534h0c-1.668-.435-3.019-1.61-3.021-2.624l-.059-37.681c-.002-1.013,1.347-1.506,3.014-1.101h0c1.669,.406,3.026,1.559,3.027,2.575l.062,37.78c.002,1.017-1.353,1.487-3.023,1.051Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.751,737.287l-.011-7.232c-.003-2.014,2.671-2.98,5.982-2.156l5.127,1.276c3.335,.83,6.049,3.149,6.052,5.178l.013,7.286c.003,2.029-2.705,2.982-6.041,2.131l-5.128-1.309c-3.312-.845-5.992-3.161-5.995-5.175Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.25,763.3h0c-1.705-.445-3.088-1.637-3.09-2.663l-.072-38.106c-.002-1.025,1.377-1.52,3.081-1.105h0c1.707,.415,3.094,1.585,3.096,2.612l.075,38.207c.002,1.028-1.383,1.5-3.091,1.054Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.474,743.811l-.013-7.314c-.004-2.036,2.73-3.006,6.116-2.163l5.242,1.305c3.411,.849,6.186,3.202,6.19,5.254l.015,7.369c.004,2.052-2.765,3.008-6.176,2.138l-5.243-1.338c-3.386-.864-6.127-3.214-6.131-5.251Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.76,770.219h0c-1.744-.455-3.158-1.665-3.161-2.702l-.085-38.541c-.002-1.036,1.407-1.533,3.151-1.109h0c1.746,.424,3.165,1.611,3.168,2.65l.088,38.644c.002,1.04-1.414,1.513-3.161,1.057Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.779,750.483l-.016-7.397c-.004-2.059,2.791-3.032,6.254-2.17l5.362,1.335c3.489,.868,6.328,3.256,6.333,5.332l.018,7.454c.005,2.076-2.827,3.035-6.316,2.144l-5.363-1.369c-3.463-.884-6.267-3.268-6.271-5.328Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.902,784.023h0c-1.498-.432-2.711-1.561-2.712-2.523l-.004-35.741c0-.961,1.212-1.413,2.71-1.008h0c1.5,.405,2.717,1.515,2.717,2.478l.006,35.83c0,.964-1.217,1.395-2.718,.963Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.218,765.669v-6.861c0-1.91,2.405-2.795,5.38-1.974l4.606,1.271c2.996,.826,5.43,3.058,5.431,4.982l.002,6.91c0,1.924-2.434,2.797-5.43,1.952l-4.606-1.3c-2.975-.84-5.381-3.068-5.382-4.978Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.174,790.726h0c-1.53-.441-2.77-1.586-2.77-2.558l-.014-36.123c0-.971,1.238-1.424,2.767-1.011h0c1.532,.414,2.775,1.539,2.776,2.513l.017,36.214c0,.975-1.243,1.406-2.775,.965Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.321,772.153l-.002-6.934c0-1.931,2.456-2.818,5.494-1.98l4.704,1.298c3.06,.844,5.547,3.107,5.548,5.051l.004,6.984c.001,1.945-2.485,2.82-5.545,1.956l-4.705-1.328c-3.039-.858-5.497-3.117-5.497-5.048Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.946,797.574h0c-1.563-.45-2.83-1.612-2.83-2.594l-.025-36.514c0-.982,1.264-1.436,2.826-1.014h0c1.565,.423,2.835,1.564,2.836,2.548l.027,36.607c0,.985-1.269,1.418-2.835,.967Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.919,778.776l-.004-7.009c-.001-1.951,2.507-2.841,5.611-1.985l4.806,1.326c3.126,.862,5.668,3.157,5.669,5.123l.006,7.06c.002,1.966-2.538,2.843-5.664,1.961l-4.806-1.356c-3.104-.876-5.616-3.167-5.617-5.119Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.234,804.57h0c-1.597-.46-2.892-1.638-2.893-2.631l-.036-36.913c0-.993,1.291-1.448,2.888-1.017h0c1.599,.432,2.898,1.589,2.899,2.584l.038,37.008c.001,.996-1.297,1.429-2.896,.969Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.027,785.542l-.006-7.085c-.002-1.973,2.561-2.864,5.732-1.989l4.91,1.355c3.194,.881,5.792,3.209,5.794,5.196l.008,7.137c.002,1.988-2.592,2.866-5.787,1.965l-4.911-1.386c-3.172-.895-5.738-3.219-5.74-5.192Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.056,811.72h0c-1.633-.47-2.956-1.665-2.957-2.67l-.047-37.32c-.001-1.003,1.319-1.46,2.951-1.019h0c1.634,.441,2.962,1.615,2.963,2.621l.05,37.418c.001,1.007-1.325,1.441-2.96,.97Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.663,792.456l-.009-7.163c-.002-1.994,2.616-2.888,5.858-1.994l5.019,1.385c3.265,.901,5.921,3.262,5.924,5.271l.01,7.216c.003,2.01-2.649,2.89-5.914,1.968l-5.02-1.417c-3.242-.915-5.865-3.272-5.868-5.267Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.428,819.028h0c-1.669-.481-3.022-1.693-3.023-2.709l-.059-37.737c-.002-1.015,1.348-1.472,3.016-1.022h0c1.671,.451,3.028,1.642,3.03,2.66l.062,37.837c.002,1.018-1.354,1.453-3.025,.972Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.844,799.523l-.011-7.243c-.003-2.017,2.673-2.912,5.987-1.998l5.131,1.416c3.338,.921,6.054,3.317,6.057,5.348l.013,7.297c.003,2.032-2.707,2.914-6.045,1.972l-5.132-1.448c-3.314-.935-5.996-3.327-5.999-5.344Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.371,826.501h0c-1.707-.492-3.09-1.722-3.092-2.749l-.072-38.164c-.002-1.026,1.378-1.485,3.084-1.024h0c1.708,.461,3.097,1.67,3.099,2.699l.075,38.266c.002,1.03-1.384,1.465-3.093,.973Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.588,806.748l-.013-7.325c-.004-2.039,2.733-2.937,6.121-2.002l5.247,1.448c3.413,.942,6.191,3.373,6.195,5.428l.015,7.38c.004,2.055-2.767,2.939-6.181,1.975l-5.248-1.481c-3.389-.956-6.132-3.383-6.136-5.423Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.903,834.144h0c-1.746-.503-3.161-1.752-3.163-2.791l-.085-38.6c-.002-1.038,1.408-1.498,3.153-1.026h0c1.747,.472,3.168,1.699,3.17,2.739l.088,38.704c.002,1.042-1.415,1.477-3.163,.974Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.915,814.137l-.016-7.408c-.004-2.063,2.794-2.962,6.259-2.006l5.367,1.481c3.491,.963,6.333,3.431,6.338,5.51l.018,7.465c.005,2.079-2.829,2.963-6.321,1.978l-5.368-1.515c-3.466-.978-6.272-3.442-6.276-5.505Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.271,
    y: 575.37,
    width: 172.46,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.271,
    y: 578.37,
    width: 172.46,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.508,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.507,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(895.129 329.024) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(950.613 273.538) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.479,
    y: 593.51,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.478,
    y: 593.509,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1006.097 218.053) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.508,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.507,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(951.138 385.031) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1006.622 329.546) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.479,
    y: 649.518,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.478,
    y: 649.517,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1062.106 274.06) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.508,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.507,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1007.146 441.038) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1062.63 385.553) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.479,
    y: 705.527,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.478,
    y: 705.526,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1118.114 330.067) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.508,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.507,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1063.155 497.046) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1118.639 441.56) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.479,
    y: 761.536,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.478,
    y: 761.535,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1174.123 386.075) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.508,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.507,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1119.164 553.053) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1174.648 497.567) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.479,
    y: 817.544,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.478,
    y: 817.544,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1230.132 442.082) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.508,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.507,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1175.172 609.06) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.993,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1230.656 553.575) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.479,
    y: 873.553,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.478,
    y: 873.552,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1286.14 498.089) rotate(89.999)",
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M446.755,306.57H216.75V0h13.702c1.683,.47,3.377,.93,5.07,1.34,25.783,6.28,52.931,1.74,79.433,3.64,9.258,.66,18.444,2.12,27.702,2.85,9.361,.73,18.783,.72,28.175,.71,12.245-.02,24.541-.04,36.612-1.97,7.708-1.23,15.499-3.25,23.228-2.12,2.946,.42,5.83,1.3,8.807,1.39,2.33,.06,4.803-.47,6.6-1.84l.677,302.57Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(231.11 228.822)",
    fontFamily: "Lato-Black, Lato",
    fontSize: 31
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".14em"
  }, "DIGI"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.629,
    y: 0,
    letterSpacing: ".069em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.646,
    y: 0,
    letterSpacing: ".14em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 130.027,
    y: 0,
    letterSpacing: ".11em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42,
    letterSpacing: ".14em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.056,
    y: 42,
    letterSpacing: ".122em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.112,
    y: 42,
    letterSpacing: ".123em"
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.16,
    y: 42,
    letterSpacing: ".14em"
  }, "TTER")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalPlotter);
export default __webpack_public_path__ + "static/media/digital-plotter.f600d51de3bb11616bdea446324481f7.svg";
export { ForwardRef as ReactComponent };